import { alertModalFields } from './alert-modal-fields.ts';

const manifest = {
  plugin_id: 3676,
  identifier: 'default_theme_v2',
  manifest_version: '1.0.10',
  api: {},
  dependency_repository_url: [],
  dependency_name: '',
  author_name: 'Applicaster',
  author_email: 'zapp@applicaster.com',
  name: 'Web Theme',
  description: 'Web Theme',
  type: 0,
  screen: false,
  react_native: true,
  ui_builder_support: true,
  whitelisted_account_ids: [],
  deprecated_since_zapp_sdk: '',
  unsupported_since_zapp_sdk: '',
  targets: ['web'],
  ui_frameworks: ['quickbrick'],
  platform: 'web',
  dependency_version: '1.0.0',
  min_zapp_sdk: '0.0.1',
  custom_configuration_fields: [
    {
      key: 'app_background_color',
      label: 'App Background color',
      type: 'color_picker_rgba',
      initial_value: 'rgba(17, 17, 17, 1)',
    },
    {
      key: 'screen_mobile_padding_top',
      label: 'Screen Mobile Padding Top',
      type: 'number_input',
      initial_value: 104,
    },
    {
      key: 'screen_tablet_padding_top',
      label: 'Screen Tablet Padding Top',
      type: 'number_input',
      initial_value: 104,
    },
    {
      key: 'screen_desktop_padding_top',
      label: 'Screen Desktop Padding Top',
      type: 'number_input',
      initial_value: 120,
    },
    {
      key: 'screen_large_desktop_padding_top',
      label: 'Screen Large Desktop Padding Top',
      type: 'number_input',
      initial_value: 120,
    },
    {
      key: 'screen_mobile_padding_bottom',
      label: 'Screen Mobile Padding Bottom',
      type: 'number_input',
      initial_value: 0,
    },
    {
      key: 'screen_tablet_padding_bottom',
      label: 'Screen Tablet Padding Bottom',
      type: 'number_input',
      initial_value: 0,
    },
    {
      key: 'screen_desktop_padding_bottom',
      label: 'Screen Desktop Padding Bottom',
      type: 'number_input',
      initial_value: 0,
    },
    {
      key: 'screen_large_desktop_padding_bottom',
      label: 'Screen Large Desktop Padding Bottom',
      type: 'number_input',
      initial_value: 0,
    },
    {
      key: 'component_mobile_maximum_width',
      label: 'Component Mobile Max Width',
      type: 'number_input',
    },
    {
      key: 'component_tablet_maximum_width',
      label: 'Component Tablet Max Width',
      type: 'number_input',
    },
    {
      key: 'component_desktop_maximum_width',
      label: 'Component Desktop Max Width',
      type: 'number_input',
    },
    {
      key: 'component_large_desktop_maximum_width',
      label: 'Component Large Desktop Max Width',
      type: 'number_input',
    },
    {
      key: 'component_mobile_margin_top',
      label: 'Component Mobile Margin Top',
      type: 'number_input',
      initial_value: 0,
    },
    {
      key: 'component_tablet_margin_top',
      label: 'Component Tablet Margin Top',
      type: 'number_input',
      initial_value: 0,
    },
    {
      key: 'component_desktop_margin_top',
      label: 'Component Desktop Margin Top',
      type: 'number_input',
      initial_value: 0,
    },
    {
      key: 'component_large_desktop_margin_top',
      label: 'Component Large Desktop Margin Top',
      type: 'number_input',
      initial_value: 0,
    },
    {
      key: 'component_mobile_margin_bottom',
      label: 'Component Mobile Margin Bottom',
      type: 'number_input',
      initial_value: 40,
    },
    {
      key: 'component_tablet_margin_bottom',
      label: 'Component Tablet Margin Bottom',
      type: 'number_input',
      initial_value: 40,
    },
    {
      key: 'component_desktop_margin_bottom',
      label: 'Component Desktop Margin Bottom',
      type: 'number_input',
      initial_value: 48,
    },
    {
      key: 'component_large_desktop_margin_bottom',
      label: 'Component Large Desktop Margin Bottom',
      type: 'number_input',
      initial_value: 48,
    },
    {
      key: 'component_mobile_padding_top',
      label: 'Component Mobile Padding Top',
      type: 'number_input',
      initial_value: 0,
    },
    {
      key: 'component_tablet_padding_top',
      label: 'Component Tablet Padding Top',
      type: 'number_input',
      initial_value: 0,
    },
    {
      key: 'component_desktop_padding_top',
      label: 'Component Desktop Padding Top',
      type: 'number_input',
      initial_value: 0,
    },
    {
      key: 'component_large_desktop_padding_top',
      label: 'Component Large Desktop Padding Top',
      type: 'number_input',
      initial_value: 0,
    },
    {
      key: 'component_mobile_padding_right',
      label: 'Component Mobile Padding Right',
      type: 'number_input',
      initial_value: 24,
    },
    {
      key: 'component_tablet_padding_right',
      label: 'Component Tablet Padding Right',
      type: 'number_input',
      initial_value: 48,
    },
    {
      key: 'component_desktop_padding_right',
      label: 'Component Desktop Padding Right',
      type: 'number_input',
      initial_value: 64,
    },
    {
      key: 'component_large_desktop_padding_right',
      label: 'Component Large Desktop Padding Right',
      type: 'number_input',
      initial_value: 64,
    },
    {
      key: 'component_mobile_padding_bottom',
      label: 'Component Mobile Padding Bottom',
      type: 'number_input',
      initial_value: 0,
    },
    {
      key: 'component_tablet_padding_bottom',
      label: 'Component Tablet Padding Bottom',
      type: 'number_input',
      initial_value: 0,
    },
    {
      key: 'component_desktop_padding_bottom',
      label: 'Component Desktop Padding Bottom',
      type: 'number_input',
      initial_value: 0,
    },
    {
      key: 'component_large_desktop_padding_bottom',
      label: 'Component Large Desktop Padding Bottom',
      type: 'number_input',
      initial_value: 0,
    },
    {
      key: 'component_mobile_padding_left',
      label: 'Component Mobile Padding Left',
      type: 'number_input',
      initial_value: 24,
    },
    {
      key: 'component_tablet_padding_left',
      label: 'Component Tablet Padding Left',
      type: 'number_input',
      initial_value: 48,
    },
    {
      key: 'component_desktop_padding_left',
      label: 'Component Desktop Padding Left',
      type: 'number_input',
      initial_value: 64,
    },
    {
      key: 'component_large_desktop_padding_left',
      label: 'Component Large Desktop Padding Left',
      type: 'number_input',
      initial_value: 64,
    },
    {
      key: 'component_mobile_gutter_vertical',
      label: 'Component Mobile Gutter Vertical',
      type: 'number_input',
      initial_value: 12,
    },
    {
      key: 'component_tablet_gutter_vertical',
      label: 'Component Tablet Gutter Vertical',
      type: 'number_input',
      initial_value: 12,
    },
    {
      key: 'component_desktop_gutter_vertical',
      label: 'Component Desktop Gutter Vertical',
      type: 'number_input',
      initial_value: 16,
    },
    {
      key: 'component_large_desktop_gutter_vertical',
      label: 'Component Large Desktop Gutter Vertical',
      type: 'number_input',
      initial_value: 16,
    },
    {
      key: 'component_mobile_gutter_horizontal',
      label: 'Component Mobile Gutter Horizontal',
      type: 'number_input',
      initial_value: 12,
    },
    {
      key: 'component_tablet_gutter_horizontal',
      label: 'Component Tablet Gutter Horizontal',
      type: 'number_input',
      initial_value: 12,
    },
    {
      key: 'component_desktop_gutter_horizontal',
      label: 'Component Desktop Gutter Horizontal',
      type: 'number_input',
      initial_value: 16,
    },
    {
      key: 'component_large_desktop_gutter_horizontal',
      label: 'Component Large Desktop Gutter Horizontal',
      type: 'number_input',
      initial_value: 16,
    },
    {
      key: 'skeleton_background_color',
      label: 'Loading Skeleton Background Color',
      type: 'color_picker_rgba',
      initial_value: 'rgba(31, 41, 55, 1)',
    },
    {
      key: 'page_loading_bar_color',
      label: 'Page Loading Bar Color',
      type: 'color_picker_rgba',
      initial_value: 'rgba(239, 239, 239, 1)',
    },
    {
      group: true,
      label: 'Popup Menu - Contextual Menu & Popover',
      folded: true,
      fields: [
        {
          key: 'popup_menu_mobile_background_color',
          label: 'Background Color Mobile',
          type: 'color_picker_rgba',
          initial_value: 'rgba(30, 30, 30, 1)',
        },
        {
          key: 'popup_menu_desktop_background_color',
          label: 'Background Color Desktop',
          type: 'color_picker_rgba',
          initial_value: 'rgba(17, 17, 17, 1)',
        },
        {
          key: 'popup_menu_mobile_border_size',
          label: 'Border Size Mobile',
          type: 'number_input',
          initial_value: 1,
        },
        {
          key: 'popup_menu_desktop_border_size',
          label: 'Border Size Desktop',
          type: 'number_input',
          initial_value: 1,
        },
        {
          key: 'popup_menu_mobile_border_color',
          label: 'Border Color Mobile',
          type: 'color_picker_rgba',
          initial_value: 'rgba(139, 139, 139, 0.1)',
        },
        {
          key: 'popup_menu_desktop_border_color',
          label: 'Border Color Desktop',
          type: 'color_picker_rgba',
          initial_value: 'rgba(139, 139, 139, 0.1)',
        },
        {
          key: 'popup_menu_mobile_corner_radius',
          label: 'Corner Radius Mobile',
          type: 'number_input',
          initial_value: 20,
        },
        {
          key: 'popup_menu_desktop_corner_radius',
          label: 'Corner Radius Desktop',
          type: 'number_input',
          initial_value: 12,
        },
        {
          key: 'popup_menu_mobile_shadow_color',
          label: 'Shadow Color Mobile',
          type: 'color_picker_rgba',
          initial_value: '#000000',
        },
        {
          key: 'popup_menu_desktop_shadow_color',
          label: 'Shadow Color Desktop',
          type: 'color_picker_rgba',
          initial_value: '#000000',
        },
        {
          key: 'popup_menu_mobile_overlay_scrim_color',
          label: 'Overlay Scrim Color Mobile',
          type: 'color_picker_rgba',
          initial_value: 'rgba(0, 0, 0, 0.6)',
        },
      ],
    },
    {
      group: true,
      label: 'Popup Menu - Alert Modal',
      folded: true,
      fields: [
        {
          key: 'popup_menu_alert_background_color_mobile',
          label: 'Alert Background Color Mobile',
          type: 'color_picker_rgba',
          initial_value: 'rgba(30, 30, 30, 1)',
        },
        {
          key: 'popup_menu_alert_background_color_desktop',
          label: 'Alert Background Color Desktop',
          type: 'color_picker_rgba',
          initial_value: 'rgba(30, 30, 30, 1)',
        },
        {
          key: 'popup_menu_alert_border_size_mobile',
          label: 'Alert Border Size Mobile',
          type: 'number_input',
          initial_value: 1,
        },
        {
          key: 'popup_menu_alert_border_size_desktop',
          label: 'Alert Border Size Desktop',
          type: 'number_input',
          initial_value: 1,
        },
        {
          key: 'popup_menu_alert_border_color_mobile',
          label: 'Alert Border Color Mobile',
          type: 'color_picker_rgba',
          initial_value: 'rgba(139, 139, 139, 0.1)',
        },
        {
          key: 'popup_menu_alert_border_color_desktop',
          label: 'Alert Border Color Desktop',
          type: 'color_picker_rgba',
          initial_value: 'rgba(139, 139, 139, 0.1)',
        },
        {
          key: 'popup_menu_alert_corner_radius_mobile',
          label: 'Alert Corner Radius Mobile',
          type: 'number_input',
          initial_value: 20,
        },
        {
          key: 'popup_menu_alert_corner_radius_desktop',
          label: 'Alert Corner Radius Desktop',
          type: 'number_input',
          initial_value: 20,
        },
        {
          key: 'popup_menu_alert_shadow_color_mobile',
          label: 'Alert Shadow Color Mobile',
          type: 'color_picker_rgba',
          initial_value: '#000000',
        },
        {
          key: 'popup_menu_alert_shadow_color_desktop',
          label: 'Alert Shadow Color Desktop',
          type: 'color_picker_rgba',
          initial_value: '#000000',
        },
        {
          key: 'popup_menu_alert_overlay_scrim_color_mobile',
          label: 'Alert Overlay Scrim Color Mobile',
          type: 'color_picker_rgba',
          initial_value: 'rgba(0, 0, 0, 0.6)',
        },
        {
          key: 'popup_menu_alert_overlay_scrim_color_desktop',
          label: 'Alert Overlay Scrim Color Desktop',
          type: 'color_picker_rgba',
          initial_value: 'rgba(0, 0, 0, 0.6)',
        },
      ],
    },
    {
      group: true,
      label: 'Popup Menu - Header',
      folded: true,
      fields: [
        {
          key: 'popup_menu_header_mobile_padding_top',
          label: 'Header Padding Top Mobile',
          type: 'number_input',
          initial_value: 10,
        },
        {
          key: 'popup_menu_header_mobile_padding_right',
          label: 'Header Padding Right Mobile',
          type: 'number_input',
          initial_value: 10,
        },
        {
          key: 'popup_menu_header_mobile_padding_bottom',
          label: 'Header Padding Bottom Mobile',
          type: 'number_input',
          initial_value: 0,
        },
        {
          key: 'popup_menu_header_mobile_padding_left',
          label: 'Header Padding Left Mobile',
          type: 'number_input',
          initial_value: 20,
        },
        {
          key: 'popup_menu_header_desktop_padding_top',
          label: 'Header Padding Top Desktop',
          type: 'number_input',
          initial_value: 10,
        },
        {
          key: 'popup_menu_header_desktop_padding_right',
          label: 'Header Padding Right Desktop',
          type: 'number_input',
          initial_value: 14,
        },
        {
          key: 'popup_menu_header_desktop_padding_bottom',
          label: 'Header Padding Bottom Desktop',
          type: 'number_input',
          initial_value: 10,
        },
        {
          key: 'popup_menu_header_desktop_padding_left',
          label: 'Header Padding Left Desktop',
          type: 'number_input',
          initial_value: 14,
        },
        {
          key: 'popup_menu_content_title_mobile_text_color',
          label: 'Header Title Color Mobile',
          type: 'color_picker_rgba',
          initial_value: '#EFEFEF',
        },
        {
          key: 'popup_menu_content_title_desktop_text_color',
          label: 'Header Title Color Desktop',
          type: 'color_picker_rgba',
          initial_value: '#EFEFEF',
        },
        {
          key: 'popup_menu_content_title_mobile_font_family',
          label: 'Header Title Font Family Mobile',
          type: 'web_font_selector',
          initial_value: 'Ubuntu-Medium',
        },
        {
          key: 'popup_menu_content_title_desktop_font_family',
          label: 'Header Title Font Family Desktop',
          type: 'web_font_selector',
          initial_value: 'Ubuntu-Bold',
        },
        {
          key: 'popup_menu_content_title_mobile_font_size',
          label: 'Header Title Font Size Mobile',
          type: 'number_input',
          initial_value: 18,
        },
        {
          key: 'popup_menu_content_title_desktop_font_size',
          label: 'Header Title Font Size Desktop',
          type: 'number_input',
          initial_value: 12,
        },
        {
          key: 'popup_menu_content_title_mobile_line_height',
          label: 'Header Title Line Height Mobile',
          type: 'number_input',
          initial_value: 32,
        },
        {
          key: 'popup_menu_content_title_desktop_line_height',
          label: 'Header Title Line Height Desktop',
          type: 'number_input',
          initial_value: 24,
        },
        {
          key: 'popup_menu_content_title_mobile_letter_spacing',
          label: 'Header Title Letter Spacing Mobile',
          type: 'number_input',
          initial_value: -0.2,
        },
        {
          key: 'popup_menu_content_title_desktop_letter_spacing',
          label: 'Header Title Letter Spacing Desktop',
          type: 'number_input',
          initial_value: -0.1,
        },
      ],
    },
    {
      group: true,
      label: 'Popup Menu - Header Action Buttons',
      folded: true,
      fields: [
        {
          key: 'popup_menu_header_action_button_desktop_default_background_color',
          label: 'Header Action Default Background Desktop',
          type: 'color_picker_rgba',
          initial_value: 'rgba(46, 46, 46, 1)',
        },
        {
          key: 'popup_menu_header_action_button_desktop_hover_background_color',
          label: 'Header Action Hover Background Desktop',
          type: 'color_picker_rgba',
          initial_value: 'rgba(62, 62, 62, 1)',
        },
        {
          key: 'popup_menu_header_action_button_desktop_text_color',
          label: 'Header Action Text Color Desktop',
          type: 'color_picker_rgba',
          initial_value: '#EFEFEF',
        },
        {
          key: 'popup_menu_header_action_button_desktop_font_family',
          label: 'Header Action Font Family Desktop',
          type: 'web_font_selector',
          initial_value: 'Ubuntu-Medium',
        },
        {
          key: 'popup_menu_header_action_button_desktop_font_size',
          label: 'Header Action Font Size Desktop',
          type: 'number_input',
          initial_value: 12,
        },
        {
          key: 'popup_menu_header_action_button_desktop_line_height',
          label: 'Header Action Line Height Desktop',
          type: 'number_input',
          initial_value: 14,
        },
        {
          key: 'popup_menu_header_action_button_desktop_letter_spacing',
          label: 'Header Action Letter Spacing Desktop',
          type: 'number_input',
          initial_value: -0.1,
        },
        {
          key: 'popup_menu_header_action_button_desktop_padding_top',
          label: 'Header Action Padding Top Desktop',
          type: 'number_input',
          initial_value: 5,
        },
        {
          key: 'popup_menu_header_action_button_desktop_padding_right',
          label: 'Header Action Padding Right Desktop',
          type: 'number_input',
          initial_value: 10,
        },
        {
          key: 'popup_menu_header_action_button_desktop_padding_bottom',
          label: 'Header Action Padding Bottom Desktop',
          type: 'number_input',
          initial_value: 5,
        },
        {
          key: 'popup_menu_header_action_button_desktop_padding_left',
          label: 'Header Action Padding Left Desktop',
          type: 'number_input',
          initial_value: 10,
        },
        {
          key: 'popup_menu_header_action_button_desktop_corner_radius',
          label: 'Header Action Corner Radius Desktop',
          type: 'number_input',
          initial_value: 12,
        },
      ],
    },
    {
      group: true,
      label: 'Popup Menu - Actions',
      folded: true,
      fields: [
        {
          key: 'popup_menu_menu_item_mobile_default_background_color',
          label: 'Action Background Default Mobile',
          type: 'color_picker_rgba',
          initial_value: 'transparent',
        },
        {
          key: 'popup_menu_menu_item_desktop_default_background_color',
          label: 'Action Background Default Desktop',
          type: 'color_picker_rgba',
          initial_value: 'transparent',
        },
        {
          key: 'popup_menu_menu_item_mobile_hover_background_color',
          label: 'Action Background Hover Mobile',
          type: 'color_picker_rgba',
          initial_value: 'rgba(46, 46, 46, 1)',
        },
        {
          key: 'popup_menu_menu_item_desktop_hover_background_color',
          label: 'Action Background Hover Desktop',
          type: 'color_picker_rgba',
          initial_value: 'rgba(46, 46, 46, 1)',
        },
        {
          key: 'popup_menu_menu_item_mobile_corner_radius',
          label: 'Action Corner Radius Mobile',
          type: 'number_input',
          initial_value: 12,
        },
        {
          key: 'popup_menu_menu_item_desktop_corner_radius',
          label: 'Action Corner Radius Desktop',
          type: 'number_input',
          initial_value: 8,
        },
        {
          key: 'popup_menu_menu_item_mobile_padding_top',
          label: 'Action Padding Top Mobile',
          type: 'number_input',
          initial_value: 14,
        },
        {
          key: 'popup_menu_menu_item_mobile_padding_right',
          label: 'Action Padding Right Mobile',
          type: 'number_input',
          initial_value: 12,
        },
        {
          key: 'popup_menu_menu_item_mobile_padding_bottom',
          label: 'Action Padding Bottom Mobile',
          type: 'number_input',
          initial_value: 14,
        },
        {
          key: 'popup_menu_menu_item_mobile_padding_left',
          label: 'Action Padding Left Mobile',
          type: 'number_input',
          initial_value: 12,
        },
        {
          key: 'popup_menu_menu_item_desktop_padding_top',
          label: 'Action Padding Top Desktop',
          type: 'number_input',
          initial_value: 10,
        },
        {
          key: 'popup_menu_menu_item_desktop_padding_right',
          label: 'Action Padding Right Desktop',
          type: 'number_input',
          initial_value: 10,
        },
        {
          key: 'popup_menu_menu_item_desktop_padding_bottom',
          label: 'Action Padding Bottom Desktop',
          type: 'number_input',
          initial_value: 10,
        },
        {
          key: 'popup_menu_menu_item_desktop_padding_left',
          label: 'Action Padding Left Desktop',
          type: 'number_input',
          initial_value: 10,
        },
        {
          key: 'popup_menu_menu_item_mobile_horizontal_gutter',
          label: 'Action Horizontal Gutter Mobile',
          type: 'number_input',
          initial_value: 12,
        },
        {
          key: 'popup_menu_menu_item_desktop_horizontal_gutter',
          label: 'Action Horizontal Gutter Desktop',
          type: 'number_input',
          initial_value: 8,
        },
        {
          key: 'popup_menu_text_label_mobile_default_color',
          label: 'Action Label Color Mobile',
          type: 'color_picker_rgba',
          initial_value: '#EFEFEF',
        },
        {
          key: 'popup_menu_text_label_desktop_default_color',
          label: 'Action Label Color Desktop',
          type: 'color_picker_rgba',
          initial_value: '#EFEFEF',
        },
        {
          key: 'popup_menu_text_label_mobile_hover_color',
          label: 'Action Label Hover Color Mobile',
          type: 'color_picker_rgba',
          initial_value: '#EFEFEF',
        },
        {
          key: 'popup_menu_text_label_desktop_hover_color',
          label: 'Action Label Hover Color Desktop',
          type: 'color_picker_rgba',
          initial_value: '#EFEFEF',
        },
        {
          key: 'popup_menu_text_label_mobile_font_family',
          label: 'Action Label Font Family Mobile',
          type: 'web_font_selector',
          initial_value: 'Ubuntu-Medium',
        },
        {
          key: 'popup_menu_text_label_desktop_font_family',
          label: 'Action Label Font Family Desktop',
          type: 'web_font_selector',
          initial_value: 'Ubuntu-Medium',
        },
        {
          key: 'popup_menu_text_label_mobile_font_size',
          label: 'Action Label Font Size Mobile',
          type: 'number_input',
          initial_value: 14,
        },
        {
          key: 'popup_menu_text_label_desktop_font_size',
          label: 'Action Label Font Size Desktop',
          type: 'number_input',
          initial_value: 12,
        },
        {
          key: 'popup_menu_text_label_mobile_line_height',
          label: 'Action Label Line Height Mobile',
          type: 'number_input',
          initial_value: 20,
        },
        {
          key: 'popup_menu_text_label_desktop_line_height',
          label: 'Action Label Line Height Desktop',
          type: 'number_input',
          initial_value: 16,
        },
        {
          key: 'popup_menu_text_label_mobile_letter_spacing',
          label: 'Action Label Letter Spacing Mobile',
          type: 'number_input',
          initial_value: -0.1,
        },
        {
          key: 'popup_menu_text_label_desktop_letter_spacing',
          label: 'Action Label Letter Spacing Desktop',
          type: 'number_input',
          initial_value: -0.1,
        },
        {
          key: 'popup_menu_action_chevron_asset',
          label: 'Action Chevron Asset',
          type: 'uploader',
          initial_value: null,
        },
      ],
    },
    {
      group: true,
      label: 'Popup Menu - Items',
      folded: true,
      fields: [
        {
          key: 'popup_menu_item_image_placeholder_color_mobile',
          label: 'Item Image Placeholder Color Mobile',
          type: 'color_picker_rgba',
          initial_value: 'rgba(62, 62, 62, 1)',
        },
        {
          key: 'popup_menu_item_image_placeholder_color_desktop',
          label: 'Item Image Placeholder Color Desktop',
          type: 'color_picker_rgba',
          initial_value: 'rgba(62, 62, 62, 1)',
        },
        {
          key: 'popup_menu_item_image_border_width_mobile',
          label: 'Item Image Border Width Mobile',
          type: 'number_input',
          initial_value: 1,
        },
        {
          key: 'popup_menu_item_image_border_width_desktop',
          label: 'Item Image Border Width Desktop',
          type: 'number_input',
          initial_value: 1,
        },
        {
          key: 'popup_menu_item_image_border_color_mobile',
          label: 'Item Image Border Color Mobile',
          type: 'color_picker_rgba',
          initial_value: 'rgba(255, 255, 255, 0.1)',
        },
        {
          key: 'popup_menu_item_image_border_color_desktop',
          label: 'Item Image Border Color Desktop',
          type: 'color_picker_rgba',
          initial_value: 'rgba(255, 255, 255, 0.1)',
        },
        {
          key: 'popup_menu_item_image_corner_radius_mobile',
          label: 'Item Image Corner Radius Mobile',
          type: 'number_input',
          initial_value: 8,
        },
        {
          key: 'popup_menu_item_image_corner_radius_desktop',
          label: 'Item Image Corner Radius Desktop',
          type: 'number_input',
          initial_value: 8,
        },
        {
          key: 'popup_menu_item_text_label_2_font_color_mobile_queue',
          label: 'Item Text Label 2 Color Mobile Queue',
          type: 'color_picker_rgba',
          initial_value: '#999999',
        },
        {
          key: 'popup_menu_item_text_label_2_font_color_desktop_queue',
          label: 'Item Text Label 2 Color Desktop Queue',
          type: 'color_picker_rgba',
          initial_value: '#999999',
        },
        {
          key: 'popup_menu_item_text_label_2_font_family_mobile_queue',
          label: 'Item Text Label 2 Font Family Mobile Queue',
          type: 'web_font_selector',
          initial_value: 'Ubuntu-Medium',
        },
        {
          key: 'popup_menu_item_text_label_2_font_family_desktop_queue',
          label: 'Item Text Label 2 Font Family Desktop Queue',
          type: 'web_font_selector',
          initial_value: 'Ubuntu-Medium',
        },
        {
          key: 'popup_menu_item_text_label_2_font_size_mobile_queue',
          label: 'Item Text Label 2 Font Size Mobile Queue',
          type: 'number_input',
          initial_value: 14,
        },
        {
          key: 'popup_menu_item_text_label_2_font_size_desktop_queue',
          label: 'Item Text Label 2 Font Size Desktop Queue',
          type: 'number_input',
          initial_value: 12,
        },
        {
          key: 'popup_menu_item_text_label_2_line_height_mobile_queue',
          label: 'Item Text Label 2 Line Height Mobile Queue',
          type: 'number_input',
          initial_value: 18,
        },
        {
          key: 'popup_menu_item_text_label_2_line_height_desktop_queue',
          label: 'Item Text Label 2 Line Height Desktop Queue',
          type: 'number_input',
          initial_value: 14,
        },
        {
          key: 'popup_menu_item_text_label_2_letter_spacing_mobile_queue',
          label: 'Item Text Label 2 Letter Spacing Mobile Queue',
          type: 'number_input',
          initial_value: -0.1,
        },
        {
          key: 'popup_menu_item_text_label_2_letter_spacing_desktop_queue',
          label: 'Item Text Label 2 Letter Spacing Desktop Queue',
          type: 'number_input',
          initial_value: -0.1,
        },
        {
          key: 'popup_menu_item_now_playing_label_font_color_mobile',
          label: 'Now Playing Label Color Mobile',
          type: 'color_picker_rgba',
          initial_value: '#EFEFEF',
        },
        {
          key: 'popup_menu_item_now_playing_label_font_color_desktop',
          label: 'Now Playing Label Color Desktop',
          type: 'color_picker_rgba',
          initial_value: '#EFEFEF',
        },
        {
          key: 'popup_menu_item_now_playing_label_font_family_mobile',
          label: 'Now Playing Label Font Family Mobile',
          type: 'web_font_selector',
          initial_value: 'Ubuntu-Bold',
        },
        {
          key: 'popup_menu_item_now_playing_label_font_family_desktop',
          label: 'Now Playing Label Font Family Desktop',
          type: 'web_font_selector',
          initial_value: 'Ubuntu-Bold',
        },
        {
          key: 'popup_menu_item_now_playing_label_font_size_mobile',
          label: 'Now Playing Label Font Size Mobile',
          type: 'number_input',
          initial_value: 12,
        },
        {
          key: 'popup_menu_item_now_playing_label_font_size_desktop',
          label: 'Now Playing Label Font Size Desktop',
          type: 'number_input',
          initial_value: 12,
        },
        {
          key: 'popup_menu_item_now_playing_label_line_height_mobile',
          label: 'Now Playing Label Line Height Mobile',
          type: 'number_input',
          initial_value: 16,
        },
        {
          key: 'popup_menu_item_now_playing_label_line_height_desktop',
          label: 'Now Playing Label Line Height Desktop',
          type: 'number_input',
          initial_value: 16,
        },
        {
          key: 'popup_menu_item_now_playing_label_letter_spacing_mobile',
          label: 'Now Playing Label Letter Spacing Mobile',
          type: 'number_input',
          initial_value: -0.1,
        },
        {
          key: 'popup_menu_item_now_playing_label_letter_spacing_desktop',
          label: 'Now Playing Label Letter Spacing Desktop',
          type: 'number_input',
          initial_value: -0.1,
        },
      ],
    },
    {
      group: true,
      label: 'Popup Menu - Icons',
      folded: true,
      fields: [
        {
          key: 'popup_menu_icons_mobile_width',
          label: 'Icon Width Mobile',
          type: 'number_input',
          initial_value: 20,
        },
        {
          key: 'popup_menu_icons_mobile_height',
          label: 'Icon Height Mobile',
          type: 'number_input',
          initial_value: 20,
        },
        {
          key: 'popup_menu_icons_desktop_width',
          label: 'Icon Width Desktop',
          type: 'number_input',
          initial_value: 16,
        },
        {
          key: 'popup_menu_icons_desktop_height',
          label: 'Icon Height Desktop',
          type: 'number_input',
          initial_value: 16,
        },
        {
          key: 'popup_menu_icons_mobile_default_color',
          label: 'Icon Default Color Mobile',
          type: 'color_picker_rgba',
          initial_value: '#EFEFEF',
        },
        {
          key: 'popup_menu_icons_mobile_active_color',
          label: 'Icon Active Color Mobile',
          type: 'color_picker_rgba',
          initial_value: '#EFEFEF',
        },
        {
          key: 'popup_menu_icons_mobile_selected_color',
          label: 'Icon Selected Color Mobile',
          type: 'color_picker_rgba',
          initial_value: '#EFEFEF',
        },
        {
          key: 'popup_menu_icons_mobile_unselected_color',
          label: 'Icon Unselected Color Mobile',
          type: 'color_picker_rgba',
          initial_value: '#EFEFEF',
        },
      ],
    },
    {
      group: true,
      label: 'Popup Menu - Dividers',
      folded: true,
      fields: [
        {
          key: 'popup_menu_divider_mobile_height',
          label: 'Divider Height Mobile',
          type: 'number_input',
          initial_value: 1,
        },
        {
          key: 'popup_menu_divider_desktop_height',
          label: 'Divider Height Desktop',
          type: 'number_input',
          initial_value: 1,
        },
        {
          key: 'popup_menu_divider_mobile_color',
          label: 'Divider Color Mobile',
          type: 'color_picker_rgba',
          initial_value: 'rgba(139, 139, 139, 0.1)',
        },
        {
          key: 'popup_menu_divider_desktop_color',
          label: 'Divider Color Desktop',
          type: 'color_picker_rgba',
          initial_value: 'rgba(139, 139, 139, 0.1)',
        },
      ],
    },
    {
      group: true,
      label: 'Popup Menu - Buttons',
      folded: true,
      fields: [
        {
          key: 'popup_menu_button_mobile_padding_right',
          label: 'Button Padding Right Mobile',
          type: 'number_input',
          initial_value: 12,
        },
        {
          key: 'popup_menu_button_mobile_padding_bottom',
          label: 'Button Padding Bottom Mobile',
          type: 'number_input',
          initial_value: 4,
        },
        {
          key: 'popup_menu_button_mobile_padding_left',
          label: 'Button Padding Left Mobile',
          type: 'number_input',
          initial_value: 12,
        },
        {
          key: 'popup_menu_button_mobile_text_color',
          label: 'Button Text Color Mobile',
          type: 'color_picker_rgba',
          initial_value: 'rgba(139, 139, 139, 0.65)',
        },
        {
          key: 'popup_menu_button_desktop_text_color',
          label: 'Button Text Color Desktop',
          type: 'color_picker_rgba',
          initial_value: '#EFEFEF',
        },
        {
          key: 'popup_menu_button_mobile_font_family',
          label: 'Button Font Family Mobile',
          type: 'web_font_selector',
          initial_value: 'Ubuntu-Medium',
        },
        {
          key: 'popup_menu_button_desktop_font_family',
          label: 'Button Font Family Desktop',
          type: 'web_font_selector',
          initial_value: 'Ubuntu-Bold',
        },
        {
          key: 'popup_menu_button_mobile_font_size',
          label: 'Button Font Size Mobile',
          type: 'number_input',
          initial_value: 14,
        },
        {
          key: 'popup_menu_button_desktop_font_size',
          label: 'Button Font Size Desktop',
          type: 'number_input',
          initial_value: 12,
        },
        {
          key: 'popup_menu_button_mobile_line_height',
          label: 'Button Line Height Mobile',
          type: 'number_input',
          initial_value: 18,
        },
        {
          key: 'popup_menu_button_desktop_line_height',
          label: 'Button Line Height Desktop',
          type: 'number_input',
          initial_value: 14,
        },
        {
          key: 'popup_menu_button_mobile_letter_spacing',
          label: 'Button Letter Spacing Mobile',
          type: 'number_input',
          initial_value: -0.1,
        },
        {
          key: 'popup_menu_button_desktop_letter_spacing',
          label: 'Button Letter Spacing Desktop',
          type: 'number_input',
          initial_value: -0.1,
        },
        {
          key: 'popup_menu_button_primary_background_color_mobile',
          label: 'Primary Button Background Mobile',
          type: 'color_picker_rgba',
          initial_value: '#EFEFEF',
        },
        {
          key: 'popup_menu_button_primary_background_color_desktop',
          label: 'Primary Button Background Desktop',
          type: 'color_picker_rgba',
          initial_value: '#EFEFEF',
        },
        {
          key: 'popup_menu_button_primary_focused_background_color_mobile',
          label: 'Primary Button Focus Background Mobile',
          type: 'color_picker_rgba',
          initial_value: '#FFFFFF',
        },
        {
          key: 'popup_menu_button_primary_focused_background_color_desktop',
          label: 'Primary Button Focus Background Desktop',
          type: 'color_picker_rgba',
          initial_value: '#FFFFFF',
        },
        {
          key: 'popup_menu_button_primary_font_color_mobile',
          label: 'Primary Button Text Color Mobile',
          type: 'color_picker_rgba',
          initial_value: '#111111',
        },
        {
          key: 'popup_menu_button_primary_font_color_desktop',
          label: 'Primary Button Text Color Desktop',
          type: 'color_picker_rgba',
          initial_value: '#111111',
        },
        {
          key: 'popup_menu_button_primary_focused_font_color_mobile',
          label: 'Primary Button Focus Text Color Mobile',
          type: 'color_picker_rgba',
          initial_value: '#111111',
        },
        {
          key: 'popup_menu_button_primary_focused_font_color_desktop',
          label: 'Primary Button Focus Text Color Desktop',
          type: 'color_picker_rgba',
          initial_value: '#111111',
        },
        {
          key: 'popup_menu_button_secondary_background_color_mobile',
          label: 'Secondary Button Background Mobile',
          type: 'color_picker_rgba',
          initial_value: '#3E3E3E',
        },
        {
          key: 'popup_menu_button_secondary_background_color_desktop',
          label: 'Secondary Button Background Desktop',
          type: 'color_picker_rgba',
          initial_value: '#3E3E3E',
        },
        {
          key: 'popup_menu_button_secondary_focused_background_color_mobile',
          label: 'Secondary Button Focus Background Mobile',
          type: 'color_picker_rgba',
          initial_value: '#4E4E4E',
        },
        {
          key: 'popup_menu_button_secondary_focused_background_color_desktop',
          label: 'Secondary Button Focus Background Desktop',
          type: 'color_picker_rgba',
          initial_value: '#4E4E4E',
        },
        {
          key: 'popup_menu_button_secondary_font_color_mobile',
          label: 'Secondary Button Text Color Mobile',
          type: 'color_picker_rgba',
          initial_value: '#EFEFEF',
        },
        {
          key: 'popup_menu_button_secondary_font_color_desktop',
          label: 'Secondary Button Text Color Desktop',
          type: 'color_picker_rgba',
          initial_value: '#EFEFEF',
        },
        {
          key: 'popup_menu_button_secondary_focused_font_color_mobile',
          label: 'Secondary Button Focus Text Color Mobile',
          type: 'color_picker_rgba',
          initial_value: '#EFEFEF',
        },
        {
          key: 'popup_menu_button_secondary_focused_font_color_desktop',
          label: 'Secondary Button Focus Text Color Desktop',
          type: 'color_picker_rgba',
          initial_value: '#EFEFEF',
        },
        {
          key: 'popup_menu_button_inactive_background_color_mobile',
          label: 'Inactive Button Background Mobile',
          type: 'color_picker_rgba',
          initial_value: '#999999',
        },
        {
          key: 'popup_menu_button_inactive_background_color_desktop',
          label: 'Inactive Button Background Desktop',
          type: 'color_picker_rgba',
          initial_value: '#2E2E2E',
        },
        {
          key: 'popup_menu_button_inactive_font_color_mobile',
          label: 'Inactive Button Text Color Mobile',
          type: 'color_picker_rgba',
          initial_value: '#111111',
        },
        {
          key: 'popup_menu_button_inactive_font_color_desktop',
          label: 'Inactive Button Text Color Desktop',
          type: 'color_picker_rgba',
          initial_value: 'rgba(239, 239, 239, 0.5)',
        },
      ],
    },
    {
      key: 'selected_action_icon',
      label: 'Selected action icon (Favorite)',
      initial_value: `data:image/svg+xml,%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M9.99452%204.67663C8.39504%202.84174%205.7278%202.34816%203.72376%204.02837C1.71972%205.70858%201.43757%208.51781%203.01136%2010.505C4.31985%2012.1572%208.27982%2015.6419%209.57768%2016.7697C9.72288%2016.8959%209.79549%2016.959%209.88017%2016.9838C9.95408%2017.0054%2010.035%2017.0054%2010.1089%2016.9838C10.1936%2016.959%2010.2662%2016.8959%2010.4114%2016.7697C11.7092%2015.6419%2015.6692%2012.1572%2016.9777%2010.505C18.5515%208.51781%2018.3038%205.69091%2016.2653%204.02837C14.2268%202.36584%2011.594%202.84174%209.99452%204.67663Z%22%20fill%3D%22%23EFEFEF%22%20stroke%3D%22%23EFEFEF%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3C%2Fsvg%3E`,
      type: 'uploader',
    },
    {
      key: 'unselected_action_icon',
      label: 'Unselected action icon (Unfavorite)',
      initial_value: `data:image/svg+xml,%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M9.99452%204.67663C8.39504%202.84174%205.7278%202.34816%203.72376%204.02837C1.71972%205.70858%201.43757%208.51781%203.01136%2010.505C4.31985%2012.1572%208.27982%2015.6419%209.57768%2016.7697C9.72288%2016.8959%209.79549%2016.959%209.88017%2016.9838C9.95408%2017.0054%2010.035%2017.0054%2010.1089%2016.9838C10.1936%2016.959%2010.2662%2016.8959%2010.4114%2016.7697C11.7092%2015.6419%2015.6692%2012.1572%2016.9777%2010.505C18.5515%208.51781%2018.3038%205.69091%2016.2653%204.02837C14.2268%202.36584%2011.594%202.84174%209.99452%204.67663Z%22%20stroke%3D%22%23EFEFEF%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3C%2Fsvg%3E`,
      type: 'uploader',
    },

    {
      key: 'play_action_button',
      label: 'Play Action Button',
      initial_value: null,
      type: 'uploader',
    },
    {
      group: true,
      label: 'Lazy Loading on Scroll',
      folded: true,
      fields: [
        {
          type: 'switch',
          label: 'Enable lazy loading on scroll',
          key: 'enable_lazy_loading_on_scroll',
          label_tooltip:
            'Enable lazy loading for components when they come into view. Use to improve performance on large layouts.',
          initial_value: false,
        },
        {
          type: 'switch',
          label: 'Limit to Safari only',
          key: 'enable_lazy_loading_on_scroll_safari',
          label_tooltip:
            'Use lazy loading only on Safari browsers (for Safari specific optimizations)',
          initial_value: false,
          conditional_fields: [
            {
              key: 'custom_configuration_fields/enable_lazy_loading_on_scroll',
              condition_value: true,
            },
          ],
        },
      ],
    },
    {
      group: true,
      label: 'Confirmation Toast / Message',
      folded: true,
      fields: [
        {
          key: 'confirmation_toast_background_color_mobile_tablet',
          label: 'Background Color (Mobile & Tablet)',
          type: 'color_picker_rgba',
          initial_value: 'rgba(1, 136, 255, 1)',
        },
        {
          key: 'confirmation_toast_background_color_desktop_large_desktop',
          label: 'Background Color (Desktop & Large Desktop)',
          type: 'color_picker_rgba',
          initial_value: 'rgba(1, 136, 255, 1)',
        },
        {
          key: 'confirmation_toast_message_font_color_mobile_tablet',
          label: 'Message Font Color (Mobile & Tablet)',
          type: 'color_picker_rgba',
          initial_value: 'rgba(239, 239, 239, 1)',
        },
        {
          key: 'confirmation_toast_message_font_color_desktop_large_desktop',
          label: 'Message Font Color (Desktop & Large Desktop)',
          type: 'color_picker_rgba',
          initial_value: 'rgba(239, 239, 239, 1)',
        },
        {
          key: 'confirmation_toast_font_family_mobile_tablet',
          label: 'Message Font Family (Mobile & Tablet)',
          type: 'web_font_selector',
          initial_value: 'Ubuntu-Medium',
        },
        {
          key: 'confirmation_toast_font_family_desktop_large_desktop',
          label: 'Message Font Family (Desktop & Large Desktop)',
          type: 'web_font_selector',
          initial_value: 'Ubuntu-Medium',
        },
        {
          key: 'confirmation_toast_line_height_mobile_tablet',
          label: 'Message Line Height (Mobile & Tablet)',
          type: 'number_input',
          initial_value: 20,
        },
        {
          key: 'confirmation_toast_line_height_desktop_large_desktop',
          label: 'Message Line Height (Desktop & Large Desktop)',
          type: 'number_input',
          initial_value: 20,
        },
        {
          key: 'confirmation_toast_letter_spacing_mobile_tablet',
          label: 'Message Letter Spacing (Mobile & Tablet)',
          type: 'number_input',
          initial_value: -0.1,
        },
        {
          key: 'confirmation_toast_letter_spacing_desktop_large_desktop',
          label: 'Message Letter Spacing (Desktop & Large Desktop)',
          type: 'number_input',
          initial_value: -0.1,
        },
        {
          key: 'confirmation_toast_border_radius_mobile_tablet',
          label: 'Corner Radius (Mobile & Tablet)',
          type: 'number_input',
          initial_value: 8,
        },
        {
          key: 'confirmation_toast_border_radius_desktop_large_desktop',
          label: 'Corner Radius (Desktop & Large Desktop)',
          type: 'number_input',
          initial_value: 8,
        },
        {
          key: 'confirmation_toast_font_size_mobile_tablet',
          label: 'Message Font Size (Mobile & Tablet)',
          type: 'number_input',
          initial_value: 14,
        },
        {
          key: 'confirmation_toast_font_size_desktop_large_desktop',
          label: 'Message Font Size (Desktop & Large Desktop)',
          type: 'number_input',
          initial_value: 15,
        },
        {
          key: 'confirmation_toast_width_mobile_tablet',
          label: 'Toast Width (Mobile & Tablet)',
          type: 'number_input',
          initial_value: 350,
        },
        {
          key: 'confirmation_toast_width_desktop_large_desktop',
          label: 'Toast Width (Desktop & Large Desktop)',
          type: 'number_input',
          initial_value: 500,
        },
        {
          key: 'confirmation_toast_close_icon',
          label: 'Close Icon (recommended 20×20px SVG or PNG)',
          type: 'uploader',
          initial_value: `data:image/svg+xml,%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M15%205L5%2015M5%205L15%2015%22%20stroke%3D%22%23EFEFEF%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E`,
        },
      ],
    },
    ...alertModalFields,
  ],
  localizations: {
    fields: [
      {
        key: 'language_label',
        label: 'Language label',
        initial_value: '',
        type: 'text_input',
      },
    ],
  },
} as const;

export default manifest;
